"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.kw_reducers = exports.reducers = void 0;
//@ts-check
var basic_1 = require("./basic");
var operators_1 = require("./operators");
var kwargs_1 = require("./kwargs");
var dtypes_1 = require("../dtypes");
var multiply = operators_1.op_binary["*"];
var divide = operators_1.op_binary["/"];
var subtract = operators_1.op_binary["-"];
var pow = operators_1.op_binary["**"];
/**
 * This function reduces an array along an axis
 */
function apply_on_axis(func, dtype, arr, axis, keepdims) {
    if (axis == null)
        return func(arr.flat);
    if (axis < 0)
        axis = arr.shape.length - 1;
    var m = arr.shape[axis];
    var shift = (0, basic_1.shape_shifts)(arr.shape)[axis];
    var groups = Array.from({ length: m }, function (_) { return []; });
    arr.flat.forEach(function (value, i) { return groups[(Math.floor(i / shift)) % m].push(value); });
    // Transpose it:
    var nCols = arr.size / m;
    var groupsT = [];
    for (var j = 0; j < nCols; j++) {
        var newRow = [];
        for (var i = 0; i < m; i++)
            newRow.push(groups[i][j]);
        groupsT.push(newRow);
    }
    //@ts-ignore
    var flat = groupsT.map(func);
    var shape = __spreadArray([], __read(arr.shape), false);
    if (keepdims)
        shape[axis] = 1;
    else
        shape = shape.filter(function (_, i) { return i != axis; });
    var out = (0, basic_1.new_NDArray)((0, dtypes_1.new_buffer)(flat, dtype), shape);
    return out.size == 1 ? out.flat[0] : out;
}
;
// ==============================
//       Reducing functions
// ==============================
function mk_reducer(flat_reduce, dtype) {
    if (!dtype)
        dtype = Float64Array;
    return function (arr, axis, keepdims) {
        return apply_on_axis(flat_reduce, dtype, arr, axis, keepdims);
    };
}
exports.reducers = {
    sum: mk_reducer(function (arr) { return arr.reduce(function (a, b) { return a + b; }, 0); }),
    product: mk_reducer(function (arr) { return arr.reduce(function (a, b) { return a * b; }, 1); }),
    mean: mk_reducer(function (arr) { return arr.reduce(function (a, b) { return a + b; }, 0) / arr.length; }),
    max: mk_reducer(function (arr) { return Math.max.apply(Math, __spreadArray([], __read(arr), false)); }),
    min: mk_reducer(function (arr) { return Math.min.apply(Math, __spreadArray([], __read(arr), false)); }),
    argmax: mk_reducer(function (arr) { return arr.indexOf(Math.max.apply(Math, __spreadArray([], __read(arr), false))); }, Int32Array),
    argmin: mk_reducer(function (arr) { return arr.indexOf(Math.min.apply(Math, __spreadArray([], __read(arr), false))); }, Int32Array),
    len: mk_reducer(function (arr) { return arr.length; }, Int32Array),
    any: mk_reducer(function (arr) {
        var e_1, _a;
        try {
            for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                var x = arr_1_1.value;
                if (x)
                    return true;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    }, Uint8Array),
    all: mk_reducer(function (arr) {
        var e_2, _a;
        try {
            for (var arr_2 = __values(arr), arr_2_1 = arr_2.next(); !arr_2_1.done; arr_2_1 = arr_2.next()) {
                var x = arr_2_1.value;
                if (!x)
                    return false;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (arr_2_1 && !arr_2_1.done && (_a = arr_2.return)) _a.call(arr_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return true;
    }, Uint8Array),
    norm: function (arr, ord, axis, keepdims) {
        if (ord % 2 != 0)
            arr = arr.abs();
        if (ord == Infinity)
            return exports.reducers.max(arr, axis, keepdims);
        if (ord == 1)
            return exports.reducers.sum(arr, axis, keepdims);
        return pow(exports.reducers.sum(pow(arr, ord), axis, keepdims), 1 / ord);
    },
    var: function (arr, axis, ddof, keepdims) {
        arr = subtract(arr, exports.reducers.mean(arr, axis, true));
        arr = multiply(arr, arr);
        if (ddof == 0)
            return exports.reducers.mean(arr, axis, keepdims);
        return divide(exports.reducers.sum(arr, axis, keepdims), arr.shape[axis] - ddof);
    },
    std: function (arr, axis, ddof, keepdims) {
        return pow(exports.reducers.var(arr, axis, ddof, keepdims), 0.5);
    },
};
exports.kw_reducers = {
    sum: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.sum),
    product: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.product),
    mean: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.mean),
    max: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.max),
    min: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.min),
    argmax: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.argmax),
    argmin: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.argmin),
    len: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.len),
    any: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.any),
    all: kwargs_1.Func_a_axis_keepdims.defaultDecorator(exports.reducers.all),
    norm: kwargs_1.Func_a_ord_axis_keepdims.defaultDecorator(exports.reducers.norm),
    var: kwargs_1.Func_a_axis_ddof_keepdims.defaultDecorator(exports.reducers.var),
    std: kwargs_1.Func_a_axis_ddof_keepdims.defaultDecorator(exports.reducers.std),
};
